import errHandles from "./errHandles";
export const isPromise = function (func) {
    return func && typeof func.then === "function";
};
export function httpCode(response, params, requestInfo) {
    const { config } = requestInfo;
    const serviceType = config === null || config === void 0 ? void 0 : config.serviceType;
    if (serviceType && serviceType === "external") {
        return response;
    }
    const data = response.data; // cloneDeep(response.data, (value) => value === null ? undefined : value);
    const code = data.code || data.Code;
    const noRepeatHrefChange = (path) => {
        if (!location.pathname.includes(path)) {
            location.href = path;
        }
    };
    if (code === undefined || code === "Success" || (code + "").startsWith("2")) {
        return response;
    }
    else if (String(code) === "401") {
        noRepeatHrefChange("/login");
    }
    else if (String(code) === "403") {
        noRepeatHrefChange("/noAuth");
    }
    return Promise.reject({
        code,
        msg: data.msg || data.Message,
    });
}
export function shortResponse(response, params, requestInfo) {
    var _a, _b, _c, _d, _e;
    if (response.skipShortResponseCopy) {
        // response上具有skipShortResponseCopy时，意味着是createService中的postRequestError启用了handleError的情形
        // 此时也被服务端包过，直接取data字段即可
        return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.Data) !== undefined ? (_b = response.data) === null || _b === void 0 ? void 0 : _b.Data : response.data;
    }
    if (((_c = requestInfo.config) === null || _c === void 0 ? void 0 : _c.concept) === "Logic") {
        // logic接口被服务端包过，因此直接取data字段即可
        return ((_d = response.data) === null || _d === void 0 ? void 0 : _d.Data) !== undefined ? (_e = response.data) === null || _e === void 0 ? void 0 : _e.Data : response.data;
    }
    const data = response === null || response === void 0 ? void 0 : response.data;
    // 兼容新Code、Data、Message
    if ((data === null || data === void 0 ? void 0 : data.Code) !== undefined) {
        data.code = data.Code;
    }
    if ((data === null || data === void 0 ? void 0 : data.Data) !== undefined) {
        data.data = data.Data;
    }
    if ((data === null || data === void 0 ? void 0 : data.Message) !== undefined) {
        data.message = data.Message;
        data.msg = data.Message;
    }
    return data;
}
// 给流程系统接口使用
export const shortResponseForSystemProcess = (response) => {
    return (response === null || response === void 0 ? void 0 : response.data) || (response === null || response === void 0 ? void 0 : response.Data) || response;
};
export const httpError = {
    reject(err, params, requestInfo) {
        const { url, config = {} } = requestInfo;
        const { method, body = {}, headers = {} } = url;
        // 处理code
        if (err === "expired request") {
            throw err;
        }
        let handle;
        if (!err.response) {
            handle = errHandles.remoteError;
        }
        else if (err.code === undefined) {
            if (err.response) {
                const code = err.response.data && (err.response.data.code || err.response.data.Code);
                if (typeof code === "number") {
                    const status = err.response.status;
                    handle = errHandles[code] || errHandles[status] || errHandles.remoteError;
                }
                else {
                    handle = errHandles.remoteError;
                }
            }
            else {
                handle = errHandles.remoteError;
            }
        }
        else {
            const code = (err.response && err.response.status) || err.code;
            handle = errHandles[code];
            if (!handle)
                handle = errHandles.defaults;
        }
        const handleOut = handle({
            config,
            baseURL: config.baseURL || "",
            url,
            method,
            body,
            headers,
        }, (err.response && err.response.data) || err);
        if (isPromise(handleOut))
            return handleOut;
        throw err;
    },
};
export function addConfigs(service) {
    if (process.env.NODE_ENV === "development") {
        service.preConfig.set("baseURL", (requestInfo, baseURL) => {
            if (!baseURL.startsWith("http")) {
                throw new Error("set baseURL only support cross domain");
            }
        });
    }
    service.postConfig.set("httpCode", httpCode);
    service.postConfig.set("httpError", httpError);
    service.postConfig.set("shortResponse", shortResponse);
    service.postConfig.set("shortResponseForSystemProcess", shortResponseForSystemProcess);
}
